<footer class="footer">
  <div class="footer-wrap">
    <div class="d-sm-flex justify-content-center justify-content-sm-between">
      <span
        class="text-muted d-block text-center text-sm-left d-sm-inline-block"
        >Copyright © 2021</span
      >
      <!-- <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
        Free
        <a href="https://www.bootstrapdash.com/" target="_blank"
          >Bootstrap dashboard templates</a
        >
        from Bootstrapdash.com</span
      > -->
    </div>
  </div>
</footer>
